(function(){
    'use strict';

    angular
    .module('appback')
    .controller('InformesController', InformesController)
 
    InformesController.$inject = ["InformeService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function InformesController(InformeService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 
        vm.users = "";
       	vm.labels = [];
	    vm.series = [];
	    vm.data = [];
	    vm.totalIncidencias = "";
	    vm.totalMuestras = "";
	    vm.totalContrastaciones = "";
	    vm.totalCaducados = "";
	    vm.totalAcciones = "";
	    vm.totalCampanas = "";
	    vm.loadingAccionesUser = false;
	    vm.loadingIncidenciasUser = false;
	    vm.loadingContrastaciones = false;
	    vm.incidencias = [];
	    vm.muestras = [];
	    vm.contrastaciones = [];
	    vm.caducados = [];

	    vm.filtrosAcciones = {};
	    vm.filtrosCuentas = {};
	    vm.filtrosContrastaciones = {"cuenta_id":[],"prueba_id":[],"patologia_id":[]};

	    vm.acciones = [];
	    vm.campanas = [];
	    vm.cuentas = [];
	    console.log("test");

	    vm.getGenericoUser = function(){
	    	vm.loadingAccionesUser = true;
	    	InformeService.getGenericoUser(vm.fecha_inicial,vm.fecha_final,vm.users,vm.filtrosAcciones,vm.filtrosCuentas,function(data){
	    		vm.loadingAccionesUser = false;
	    		vm.acciones = data.acciones;
	    		vm.cuentas = data.cuentas;
	    		vm.totalAcciones = data.totalAcciones;
	    		vm.totalCampanas = data.totalCampanas;
	    		vm.campanas = data.campanas;
	    		vm.totalCuentas = data.totalCuentas;
                console.log(data);
            });
	    }

	    vm.getContrastacionesIng = function(){
	    	vm.loadingContrastaciones = true;
	    	InformeService.getContrastaciones(vm.fecha_inicial,vm.fecha_final,vm.users,vm.filtrosContrastaciones,function(data){
	    		vm.loadingContrastaciones = false;
	    		vm.contrastaciones = data.contrastaciones
	    	
                //console.log(data);
            });
	    }

	    vm.getAccionesUser = function(){
	    	vm.loadingAccionesUser = true;
	    	InformeService.getAccionesUsuario(vm.fecha_inicial,vm.fecha_final,vm.users,function(data){
	    		vm.labels = data.labels;
	    		vm.series = data.series;
	    		vm.data = data.data;
	    		vm.loadingAccionesUser = false;
                console.log(data);
            });
	    }

	    vm.getIncidenciasUser = function(){
	    	vm.loadingIncidenciasUser = true;
	    	vm.loadingContrastaciones = true;
	    	InformeService.getIncidenciasUsuario(vm.fecha_inicial,vm.fecha_final,vm.users,function(data){
	    		vm.loadingIncidenciasUser = false;
	    		vm.loadingContrastaciones = false;
	    		vm.incidencias = data.incidencias;
	    		vm.totalIncidencias = data.totalIncidencias;
	    		vm.totalMuestras = data.totalMuestras;
	    		vm.contrastaciones = data.contrastaciones
	    		vm.caducados = data.caducados
	    		vm.muestras = data.muestras
	    		vm.totalContrastaciones = data.totalContrastaciones;
	    		vm.totalCaducados = data.totalCaducados;
                console.log(data);
            });
	    }
	}
  
})();